(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-localization"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.lang-switch__link').forEach(function (link) {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    var value = link.dataset.value;
    document.cookie = 'userSelectedLanguage=' + encodeURIComponent(value) + ';path=/;max-age=2592000';
    document.cookie = 'RedirectedFirstTime=1;path=/;max-age=2592000';
    var form = link.closest('form');
    var input = form ? form.querySelector('input[name="locale_code"]') : null;
    if (input) {
      input.value = value;
    }
    if (form) {
      form.submit();
    }
  });
});

document.addEventListener('click', function (event) {
  document.querySelectorAll('details.lang-switch[open]').forEach(function (details) {
    if (!details.contains(event.target)) {
      details.removeAttribute('open');
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
